import { render, staticRenderFns } from "./scadenzario.vue?vue&type=template&id=20dff38f&lang=html&"
import script from "./scadenzario.vue?vue&type=script&lang=js&"
export * from "./scadenzario.vue?vue&type=script&lang=js&"
import style0 from "./scadenzario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports